"use client";

import { Logo } from "@/components/ui/logo";
import { heroButtonVisibility } from "@/features/landing/ui/hero-text-section";
import { StartButton } from "@/features/landing/ui/start-button";
import { useCommonTranslation } from "@/features/i18n/libs/useCommonTranslation";
import { useCallback, useEffect, useRef } from "react";
import { staticFooterVisibility } from "@/features/landing/ui/static-footer";

export function LandingHeaderDesktop() {
  const { t } = useCommonTranslation();
  const animationRef = useRef<HTMLDivElement>(null);
  const isVisibleRef = useRef(true);
  const isStaticFooterVisibleRef = useRef(staticFooterVisibility.isVisible);

  useEffect(() => {
    const updateVisibility = () => {
      const wasVisible = isVisibleRef.current;
      const isHeroVisible = heroButtonVisibility.isVisible;
      const isStaticFooterVisible = isStaticFooterVisibleRef.current;
      const isVisible = isHeroVisible && !isStaticFooterVisible;

      if (wasVisible !== isVisible) {
        isVisibleRef.current = isVisible;
        if (animationRef.current) {
          animationRef.current.style.transform = `translateY(${isVisible ? "-100px" : "0px"})`;
        }
      }
    };

    const updateStaticFooterVisibility = () => {
      isStaticFooterVisibleRef.current = staticFooterVisibility.isVisible;
      updateVisibility();
    };

    updateVisibility();
    const unsubscribeHero = heroButtonVisibility.subscribe(updateVisibility);
    const unsubscribeFooter = staticFooterVisibility.subscribe(
      updateStaticFooterVisibility,
    );

    return () => {
      unsubscribeHero();
      unsubscribeFooter();
    };
  }, []);

  const handleLogoClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    [],
  );

  return (
    <div className="hidden lg:block">
      <div className="fixed left-[60px] top-4 z-[9999]">
        <button onClick={handleLogoClick} className="inline-block">
          <div className="rounded-lg bg-white/10 p-4 backdrop-blur-md">
            <Logo variant="small" colored font="nunitoSans" />
          </div>
        </button>
      </div>

      <div
        ref={animationRef}
        className="fixed right-[60px] top-4 z-[9999] transition-transform duration-300 ease-in-out"
        style={{ transform: "translateY(-100px)" }}
      >
        <div className="flex items-center gap-5">
          <a href="#faq" className="text-black hover:underline">
            {t("landing:faq_link")}
          </a>
          <a href="/report/example" className="text-black hover:underline">
            {t("landing:sample_report_link")}
          </a>
          <StartButton variant="header" />
        </div>
      </div>
    </div>
  );
}
